var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.hide
        ? _c("section", { class: ["box-typical", "files-manager"] }, [
            _c(
              "div",
              { ref: "content-container", staticClass: "files-manager-panel" },
              [
                _c("div", { staticClass: "files-manager-panel-in ml-0" }, [
                  _c("header", { staticClass: "files-manager-header p-2" }, [
                    _c("div", { staticClass: "files-manager-header-left" }, [
                      _c("div", { staticClass: "search" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search,
                              expression: "search"
                            }
                          ],
                          staticClass: "form-control form-control-rounded",
                          attrs: { type: "text", placeholder: "Search" },
                          domProps: { value: _vm.search },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.search = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(0)
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "files-manager-header-right mt-1" },
                      [
                        _c("div", { staticClass: "header-buttons p-0" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-rounded btn-sm",
                              attrs: { type: "button" },
                              on: { click: _vm.showUploadModal }
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("cloud_upload")
                              ]),
                              _vm._v(
                                "\n                                Upload Asset\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-rounded btn-success btn-sm",
                              attrs: { type: "button" },
                              on: { click: _vm.createFolder }
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("create_new_folder")
                              ]),
                              _vm._v(
                                "\n                                New Folder\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              class: [
                                "btn",
                                "btn-rounded",
                                "btn-default",
                                "btn-sm",
                                _vm.updatingCache ? "btn--state-loading" : ""
                              ],
                              attrs: {
                                type: "button",
                                disabled: _vm.updatingCache
                              },
                              on: { click: _vm.updateCache }
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("cached")
                              ]),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.updatingCache
                                      ? "Updating..."
                                      : "Refresh"
                                  ) +
                                  "\n                            "
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "files-manager-content" }, [
                    _c(
                      "section",
                      { staticClass: "files-manager-aside w-100" },
                      [
                        _c(
                          "h3",
                          _vm._l(_vm.assetPath, function(node, idx) {
                            return _c(
                              "drop",
                              {
                                key: node.id,
                                attrs: { tag: "span" },
                                on: {
                                  drop: function(fromId) {
                                    return _vm.onMoveAsset(
                                      node.id,
                                      fromId,
                                      node.isStorage
                                    )
                                  }
                                }
                              },
                              [
                                idx > 0
                                  ? _c(
                                      "i",
                                      { staticClass: "material-icons mr-0" },
                                      [_vm._v("keyboard_arrow_right")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !node.isCurrent
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function($event) {
                                            return _vm.onPathClick(
                                              node.id,
                                              node.isStorage
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              node.label ||
                                                _vm.__(node.name, ["titleCase"])
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          node.label ||
                                            _vm.__(node.name, ["titleCase"])
                                        )
                                      )
                                    ])
                              ]
                            )
                          }),
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "files-manager-content-in scrollable-block asset-modal"
                      },
                      [
                        _c(
                          "nav",
                          {
                            class: [
                              "files-manager-side",
                              _vm.showStoragePanel ? "" : "hide"
                            ]
                          },
                          [
                            _c(
                              "header",
                              { staticClass: "files-manager-side-title" },
                              [_vm._v("Storage")]
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "files-manager-side-list" },
                              _vm._l(_vm.storageList, function(storage) {
                                return _c("li", { key: storage.name }, [
                                  _c(
                                    "a",
                                    {
                                      class: [
                                        storage.name === _vm.currentStorage
                                          ? "active"
                                          : ""
                                      ],
                                      staticStyle: { "border-bottom": "0px" },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectStorage(storage.name)
                                        }
                                      }
                                    },
                                    [
                                      storage.icon
                                        ? _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v(_vm._s(storage.icon))]
                                          )
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            storage.label ||
                                              _vm.__(storage.name, [
                                                "titleCase"
                                              ])
                                          ) +
                                          "\n                                        "
                                      ),
                                      storage.description
                                        ? _c("small", {
                                            staticClass: "d-block",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                storage.description
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              }),
                              0
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-3 mr-3" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sortBy,
                                    expression: "sortBy"
                                  }
                                ],
                                staticClass: "form-control w-100",
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.sortBy = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.sortOptions, function(option) {
                                return _c(
                                  "option",
                                  { domProps: { value: option.id } },
                                  [_vm._v(_vm._s(option.name))]
                                )
                              }),
                              0
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col" },
                            [
                              _vm.pagination.last_page > 1
                                ? _c("b-pagination", {
                                    attrs: {
                                      align: "right",
                                      size: "md",
                                      limit: 6,
                                      "total-rows": _vm.pagination.total,
                                      "per-page": _vm.pagination.per_page
                                    },
                                    model: {
                                      value: _vm.pagination.current_page,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.pagination,
                                          "current_page",
                                          $$v
                                        )
                                      },
                                      expression: "pagination.current_page"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: [
                              "fm-file-container",
                              _vm.showStoragePanel ? "fm-file-padded" : ""
                            ]
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fm-file-grid",
                                on: { click: _vm.resetSelect }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "fm-file-grid-in" },
                                  [
                                    _vm._l(_vm.inViewFolders, function(asset) {
                                      return _c(
                                        "div",
                                        {
                                          key: asset.id,
                                          class: [
                                            "fm-file",
                                            "fm-folder",
                                            _vm.isAssetSelected(asset) ||
                                            asset.id == _vm.dragging
                                              ? "selected"
                                              : ""
                                          ],
                                          on: {
                                            click: function(e) {
                                              e.stopPropagation()
                                              _vm.checkAndSelectAsset(asset)
                                            },
                                            dblclick: function(e) {
                                              e.stopPropagation()
                                              _vm.checkAndGetAsset(asset)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "drag",
                                            {
                                              attrs: {
                                                "transfer-data": asset.id
                                              }
                                            },
                                            [
                                              _vm.isAssetSelected(asset)
                                                ? _c("input", {
                                                    staticClass: "checkbox",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: _vm.isAssetSelected(
                                                        asset
                                                      )
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "file-border" },
                                                [
                                                  _c(
                                                    "drop",
                                                    {
                                                      on: {
                                                        dragover: function(
                                                          fromId
                                                        ) {
                                                          return _vm.onMoveAssetOver(
                                                            asset.id,
                                                            fromId,
                                                            false
                                                          )
                                                        },
                                                        dragleave: function(
                                                          fromId
                                                        ) {
                                                          return _vm.onMoveAssetLeave(
                                                            asset.id,
                                                            fromId,
                                                            false
                                                          )
                                                        },
                                                        drop: function(fromId) {
                                                          return _vm.onMoveAsset(
                                                            asset.id,
                                                            fromId,
                                                            false
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fm-file-icon"
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/img/folder.svg",
                                                              alt: "Folder"
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fm-file-name"
                                                        },
                                                        [
                                                          _c("p", [
                                                            _vm._v(
                                                              _vm._s(asset.name)
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fm-file-size"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getFolderSize(
                                                                asset.id
                                                              )
                                                            ) + " files"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.inViewFiles, function(asset) {
                                      return _c(
                                        "div",
                                        {
                                          key: asset.id,
                                          class: [
                                            "fm-file asset",
                                            _vm.checkExtension(asset)
                                              ? ""
                                              : "disabled",
                                            _vm.isAssetSelected(asset)
                                              ? "selected"
                                              : ""
                                          ],
                                          on: {
                                            click: function(e) {
                                              e.stopPropagation()
                                              _vm.checkAndSelectAsset(asset)
                                            },
                                            dblclick: function(e) {
                                              e.stopPropagation()
                                              _vm.checkAndGetAsset(asset.id)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "drag",
                                            {
                                              attrs: {
                                                "transfer-data": asset.id
                                              }
                                            },
                                            [
                                              _c("input", {
                                                staticClass: "checkbox",
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked: _vm.isAssetSelected(
                                                    asset
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "file-border" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "fm-file-icon"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: _vm.getIcon(
                                                            asset
                                                          ),
                                                          alt: ""
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "fm-file-name"
                                                    },
                                                    [
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(asset.name)
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "fm-file-dimension"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getDimension(
                                                            asset
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "fm-file-size"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getFileSize(
                                                            asset.size
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("section", { staticClass: "files-manager-aside" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.assetInfo
                      ? _c(
                          "div",
                          { staticClass: "files-manager-aside-section" },
                          [
                            _vm.currentAssets.length > 0
                              ? _c("div", { staticClass: "text-center" }, [
                                  _c(
                                    "div",
                                    { staticClass: "box-typical-header-cm" },
                                    [
                                      _c("p", { staticClass: "asset-name" }, [
                                        _vm._v(_vm._s(_vm.assetInfo.name))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-rounded btn-md btn-danger",
                                      on: { click: _vm.deleteAssets }
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("delete")]
                                      ),
                                      _vm._v(
                                        "\n                                Delete selected\n                            "
                                      )
                                    ]
                                  )
                                ])
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "box-typical-header-sm" },
                                    [
                                      _c("inline-input-component", {
                                        staticClass: "asset-name",
                                        attrs: {
                                          initialValue: _vm.assetInfo.name
                                        },
                                        on: { change: _vm.updateAssetName }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.getFiletype(_vm.assetInfo.extension) ==
                                  "img"
                                    ? _c("img", {
                                        staticClass: "w-100",
                                        attrs: {
                                          src:
                                            _vm._.imgPath(
                                              _vm.assetInfo,
                                              "w264"
                                            ) +
                                            "?" +
                                            _vm.timestamp
                                        },
                                        on: { load: _vm.adjustHeight }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getFiletype(_vm.assetInfo.extension) ==
                                  "pdf"
                                    ? _c("img", {
                                        staticClass: "w-100",
                                        attrs: {
                                          src:
                                            _vm._.imgPath(_vm.assetInfo) +
                                            "?" +
                                            _vm.timestamp
                                        },
                                        on: { load: _vm.adjustHeight }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "info-list" }, [
                                    _c(
                                      "table",
                                      {
                                        staticClass: "table-sidebar",
                                        attrs: { width: "100%" }
                                      },
                                      [
                                        _c("tr", [
                                          _c("td", [_vm._v("System ID")]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [_vm._v(_vm._s(_vm.assetInfo.id))]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [_vm._v("Created")]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.__(
                                                    _vm.assetInfo.created_at,
                                                    ["datetime"]
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [_vm._v("Dimension")]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getDimension(
                                                    _vm.assetInfo
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        ["dir"].indexOf(
                                          _vm.assetInfo.extension
                                        ) >= 0
                                          ? _c("tr", [
                                              _c("td", [_vm._v("Files")]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getFolderSize(
                                                        _vm.assetInfo.id
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ])
                                          : _c("tr", [
                                              _c("td", [_vm._v("Size")]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getFileSize(
                                                        _vm.assetInfo.size
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [_vm._v("Extension")]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.assetInfo.extension)
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._m(2),
                                        _vm._v(" "),
                                        _vm._.values(_vm.assetInfo.usage)
                                          .length > 0
                                          ? [
                                              _vm._m(3),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "2" } },
                                                  [
                                                    _c(
                                                      "table",
                                                      {
                                                        staticStyle: {
                                                          "font-size": ".65rem",
                                                          "font-weight":
                                                            "initial",
                                                          width: "100%"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "tbody",
                                                          _vm._l(
                                                            _vm.getUsageHtml(
                                                              _vm.assetInfo
                                                            ),
                                                            function(trHtml) {
                                                              return _c("tr", {
                                                                domProps: {
                                                                  innerHTML: _vm._s(
                                                                    trHtml
                                                                  )
                                                                }
                                                              })
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          : _c("tr", [
                                              _c("td", [_vm._v("Used")]),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [_vm._v("---")]
                                              )
                                            ])
                                      ],
                                      2
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "files-manager-aside-section-button"
                                    },
                                    [
                                      _vm.assetInfo.extension != "dir"
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-secondary btn-block btn-rounded ",
                                              on: {
                                                click: function($event) {
                                                  return _vm.cacheAsset(
                                                    _vm.assetInfo
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons"
                                                },
                                                [_vm._v("restore")]
                                              ),
                                              _vm._v(
                                                "\n                                    Cache Asset\n                                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.assetInfo.extension != "dir"
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-secondary btn-block btn-rounded ",
                                              on: {
                                                click:
                                                  _vm.showAssetReplacePrompt
                                              }
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons"
                                                },
                                                [_vm._v("find_replace")]
                                              ),
                                              _vm._v(
                                                "\n                                    Replace Asset\n                                    "
                                              ),
                                              _c("input", {
                                                ref: "fm-replace-asset",
                                                staticClass: "hide",
                                                attrs: { type: "file" },
                                                on: {
                                                  change: function(e) {
                                                    return _vm.replaceAsset(
                                                      _vm.assetInfo,
                                                      e
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.assetInfo.extension != "dir"
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-secondary btn-block btn-rounded ",
                                              on: {
                                                click: function($event) {
                                                  _vm.copyClipboard(
                                                    _vm._.assetPath(
                                                      _vm.assetInfo
                                                    )
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons"
                                                },
                                                [_vm._v("content_copy")]
                                              ),
                                              _vm._v(
                                                "\n                                    Copy URL\n                                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.imageEditable &&
                                      _vm._.includes(
                                        _vm.editableExtensions,
                                        _vm.assetInfo.extension
                                      )
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-rounded btn-block mb-1 ",
                                              attrs: {
                                                href: "#" + _vm.assetInfo.link
                                              }
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons"
                                                },
                                                [_vm._v("edit")]
                                              ),
                                              _vm._v(
                                                "\n                                    Edit Image\n                                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.assetInfo.extension !== "dir"
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-rounded btn-block mb-1 ",
                                              attrs: {
                                                href:
                                                  _vm.assetInfo.link +
                                                  "?download",
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "font-icon-left font-icon-download-3"
                                              }),
                                              _vm._v(" "),
                                              _vm._v(
                                                "\n                                    Download\n                                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-block btn-rounded btn-danger",
                                          on: { click: _vm.deleteAsset }
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("delete")]
                                          ),
                                          _vm._v(
                                            "\n                                    Delete\n                                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("upload-modal-component", {
        attrs: {
          extensions: _vm.extensions,
          uploadFile: _vm.uploadFile,
          active: _vm.isUploading
        },
        on: { "modal-close": _vm.hideUploadModal }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn-icon", attrs: { type: "submit" } },
      [_c("i", { staticClass: "font-icon font-icon-search" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("i", { staticClass: "material-icons" }, [_vm._v("build")]),
      _vm._v("Toolbar")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("Creator")]),
      _vm._v(" "),
      _c("td", { staticClass: "text-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("Used")]),
      _c("td", { staticClass: "text-right" })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d92c2db2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d92c2db2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/AssetManagerComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d92c2db2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/AssetManagerComponent.vue
// module chunks = 0